module.exports = __webpack_public_path__ + "static/SFMono-Regular-d892da9f8895428033ec68a6c0426ba6.ttf";